import { Box, MenuDivider } from '@bechtel/gds';
import { filter, isNil, orderBy } from 'lodash';
import { FC, useRef } from 'react';
import { MultiLingualText } from '~/components/atoms';
import { useOutsideClick } from '~/hooks';
import { MoreOptions, MoreOptionsItem } from './items';
import { DrawerBackdropStyled, DrawerOuterStyled, SideSheetBodyStyled, SideSheetContentColStyled } from './styled';

interface MoreOptionsNavProps {
  showMoreSelect: (item: MoreOptionsItem) => void;
  moreOptionsItems: MoreOptionsItem[];
  setMoreOptions: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MoreOptionsNav: FC<MoreOptionsNavProps> = ({ showMoreSelect, moreOptionsItems, setMoreOptions }) => {
  const moreCommodities = filter(moreOptionsItems, (item) => item.editList !== null);
  const otherCommodities = orderBy(
    filter(moreOptionsItems, (item) => item.editList === null && !isNil(item.browseList)),
    (item) => item.title.toLowerCase()
  );

  const ref = useRef();
  useOutsideClick(ref, () => {
    setMoreOptions(false);
  });

  return (
    <DrawerBackdropStyled ref={ref} onClick={() => setMoreOptions(false)}>
      <DrawerOuterStyled onClick={(event) => event.stopPropagation()}>
        <SideSheetBodyStyled>
          <SideSheetContentColStyled>
            <MultiLingualText size={400} weight={600}>
              More Commodities
            </MultiLingualText>
            <Box flexGrow={{ sm: '1' }} my={{ sm: '450' }}>
              <MoreOptions items={moreCommodities} showMoreSelect={showMoreSelect} />
            </Box>
            <MenuDivider />
            <Box flexDirection={{ sm: 'column' }} pt={{ sm: '400' }}>
              <MultiLingualText>Other Commodities</MultiLingualText>
              <Box flexGrow={{ sm: '1' }} my={{ sm: '450' }}>
                <MoreOptions items={otherCommodities} showMoreSelect={showMoreSelect} />
              </Box>
            </Box>
          </SideSheetContentColStyled>
        </SideSheetBodyStyled>
      </DrawerOuterStyled>
    </DrawerBackdropStyled>
  );
};
